import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import useLogout from "../../hooks/useLogout";
import { useForm } from "react-hook-form";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
  PreviewAltCard,
  TooltipComponent,
} from "../../components/Component";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import { Badge, Col, Form, Row } from "reactstrap";
import { listPharmacyAPI, listPharmacyTelecaller, updatePharmacyAPI } from "../../api/pahrmacy";
import { toast } from "react-toastify";
import { BASE_URL_IMG } from "../../assets/constants";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import { useLocation, useNavigate } from "react-router";
import { UserAvatarCell } from "../../MyComp/ImageView/UserAvatarCell";
import MyButton from "../../MyComp/UI/form/MyButton";

const PharmacyDetailsTeleCaller = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      data: [],
    },
  });
  const navigate = useNavigate();
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const [data, setData] = useState([]);
  
  const [column, setColumn] = useState([
    {
      name: "Store",
      selector: (row) => row?.store_name,
      cell: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            padding: "6px 0",
          }}
        >
          {/* <img
            onClick={() => handleImageOpenPreview(`${BASE_URL_IMG}` + row?.store_image)}
            src={row?.store_image ? `${BASE_URL_IMG}${row.store_image}` : "/default-avatar.png"}
            alt={row?.store_name || "Store"}
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #e5e7eb",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          /> */}
          <UserAvatarCell
            row={row}
            name={row?.store_name}
            handleImageOpenPreview={handleImageOpenPreview}
            image={`${BASE_URL_IMG}${row.store_image}`}
          />

          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontWeight: 600,
                fontSize: "15px",
                color: "#111827",
                lineHeight: "1.2",
              }}
            >
              {row?.store_name || "N/A"}
            </span>
            <span
              style={{
                fontSize: "13px",
                color: "#6b7280",
              }}
            >
              {row?.email}
            </span>
            <span
              style={{
                fontSize: "13px",
                color: "#6b7280",
              }}
            >
              {row?.mobile || row?.contact_number}
            </span>
          </div>
        </div>
      ),
      sortable: true,
      width: "250px",
    },

    // {
    //   name: "Type",
    //   selector: (row) => row?.store_type,
    //   sortable: true,
    // },
    {
      name: "Mobile",
      selector: (row) => row?.mobile,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row?.email,
      sortable: true,
    },
    {
      name: "Distance",
      selector: (row) => <>{row?.distance} Km.</>,
      sortable: true,
    },
    {
      name: "Pincode",
      selector: (row) => row?.pincode,
      sortable: true,
    },
    {
      name: "Address",
      selector: (row) => row?.address,
      sortable: true,
    },




    {
      name: "Action",
      wrap: true,
      // width: "220px",
      cell: (row) => (
        <div>
              <Button id={`dash-${row?.id}`} outline color={`primary`} size={`xs`} className={`me-1`} onClick={() => handleGoDashboard(row)}
                style={{ marginLeft: "6px", marginBottom: "6px" }}>
                {" "}
                <Icon name="presentation" />
              </Button>
              <TooltipComponent iconClass="card-hint" direction="top" id={`dash-${row?.id}`} text="Order" />
     
  
        </div>
      ),
    },
  ]);
  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };
  const handleGoDashboard = (row) => {
    
    navigate("/pharmacy-dashboard", { state: { pharmacyId: row?.id, name: row?.store_name } });
  };
  const handleShowDetails = (row) => {
    navigate("/pharmacy-detail", { state: { pharmacyId: row?.id, mode: "Approval" } });
  };
  //   const handleEditDetails = (row) => {
  //   navigate("/pharmacy-update", { state: { pharmacyId: row?.id, mode: "Edit" } });
  // };
  const handleEditDetails = (row) => {
    navigate("/pharmacy-registration/pharmacy-basic-details", { state: { pharmacyId: row?.id, mode: "Edit" } });
  };
  const handleImageOpenPreview = (row, name) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };
  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };
  useEffect(() => {
    getPharmacyList();
  }, []);
  const location = useLocation();
  console.log(location, "location");
  const getPharmacyList = () => {
    setValue("isLoading", true);
    listPharmacyTelecaller({ orderId: location.state.orderId })
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        } else if (res.data.status === true) {
          toast.clearWaitingQueue();
          setData(res?.data?.data?.nearbyPharmacies);
          resetForm();
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setData([]);
          toast.error(!res.data.message);
          toast.clearWaitingQueue();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      })
      .finally(() => {
        setValue("isLoading", false);
      });
  };
  const resetForm = () => {};
  const confirmStatusChange = () => {
    const formData = new FormData();
    const updatedStatus = watch("selectedRow").status === true ? false : true;
    formData.append("pharmacy_id", watch("selectedRow")?.id);
    formData.append("status", updatedStatus);

    updatePharmacyAPI(formData).then((res) => {
      if (res.data.status === true) {
        toast.success(res.data.message);
        toast.clearWaitingQueue();
        getPharmacyList();
        setShowModal(false);
      } else if (res.data.status === false) {
        toast.error(res.data.message);
        toast.clearWaitingQueue();
      } else if (res.data.status === "expired") {
        toast.error(res.data.message);
        toast.clearWaitingQueue();
        logout();
      }
    });
  };

  const truncateByWords = (text = "", wordLimit = 5) => {
    if (!text) return "";

    const words = text.trim().split(/\s+/);
    return words.length > wordLimit ? words.slice(0, wordLimit).join(" ") + " ..." : text;
  };
    const onFormSubmit = async (data) => {
   
    };

  return (
    <>
      <Head title={"Pharmacy "} />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {" Pharmacy"}
              </BlockTitle>
            </BlockHeadContent>

            {/* <BlockHeadContent>
                
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  // onClick={() =>  navigate("/pharmacy-detail")}
                  onClick={() => navigate("/pharmacy-registration/pharmacy-basic-details", { state: { mode: "Add" } })}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent> */}
            <BlockHeadContent>
              {" "}
                 <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  // onClick={() =>  navigate("/pharmacy-detail")}
                  onClick={() => navigate("/telecaller-pharmacy", { state: { mode: "Add" } })}
                >
                  <Icon name={"arrow-left"}/>
                </Button>
              {/* <Button
                onClick={() => {
                  navigate("/telecaller-pharmacy");
                }}
                className="search-back btn-icon toggle-search"
              >
                <Icon name="arrow-left"></Icon>
              </Button> */}
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
     
          {isOpen && (
            <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                  {/* <Col md="3">
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Discount Type"
                      name="discountType"
                      placeholder="Select discount type"
                      required
                      options={discountType}
                      disabled={mode === "Approval"}
                    />
                  </Col> */}
           
                  {/* <Col md="3">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Pacakge Details"
                      name="package-detail"
                      placeholder="Enter package details"
                      required
                    />
                  </Col> */}
             
              
                </Row>{" "}
                <Col md="4">
                  <MyButton isLoading={isLoading} mode={mode} />
                </Col>
              </Form>
            </PreviewAltCard>
          )}     <MyDataTable title={"Pharmacy "} isLoading={isLoading} columns={column} data={data || []} />
        </Block>
      </Content>
      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
        data={watch("selectedRow")}
      />
      <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
    </>
  );
};

export default PharmacyDetailsTeleCaller;
